import React from "react";
import "./Styles.css";
import Awgment from "../assets/icons/augment-logo.svg";
import homePageImage from "../assets/icons/Awgment_Homepage_image.png";
import { Box } from "@mui/material";

const Dashboard = () => {
  return (
    <div className="dashboard-container">
      <Box display="flex" justifyContent="center" width="100%">
        <div
          className="home-header-text"
          style={{ display: "flex", alignItems: "center", gap: "10px" }}
        >
          AWGMENT
          <img
            src={Awgment}
            alt="company-logo"
            className="dashboard-awgment-logo"
          />
        </div>
      </Box>

      <div className="dashboard-home-icon">
        <img
          src={homePageImage}
          alt="home-icon"
          className="dashboard-home-image"
        />
      </div>
    </div>
  );
};

export default Dashboard;
